import { getTokenResult } from '../data'

class MockKeycloak {
  constructor() {
    this.authenticated = true
    this.token = getTokenResult.access_token
    this.refreshToken = getTokenResult.refresh_token
    this.idToken = getTokenResult.id_token
    this.tokenParsed = {
      exp: 1760511634,
      iat: 1760509834,
      auth_time: 1760508994,
      jti: 'onrtac:43fa24fe-27d5-d2c1-a2fa-4b66f3c432a5',
      iss: 'https://id.eu.test.tomra.cloud/auth/realms/TomraConnectUsers',
      aud: [
        'report-manager-api',
        'account-management',
        'mytomra-api',
        'voucher-control-api',
        'assortment-management-api',
        'status-api',
        'tp-reporting',
        'promotion-api',
        'account',
        'masterdata-api'
      ],
      sub: 'd4594099-d7df-4393-8eb1-80b9dcb7da78',
      typ: 'Bearer',
      azp: 'voucher-admin-ui',
      sid: '5d22f52f-5f75-4194-9af5-ffe023ab366e',
      acr: '0',
      'allowed-origins': [
        'https://eu.test.voucher-admin.tomra.cloud',
        '*',
        'https://eu.test.voucher-manager.tomra.cloud'
      ],
      scope: 'openid profile email',
      email_verified: true,
      scoped_resource_access: [
        'RVMStatusApi#User#2b63751d-575f-4e95-88c1-2473dabe9919#STATUS_READ;WEBHOOK_MANAGEMENT',
        'DeveloperPortal#User#3c7851cb-173f-486c-ae61-c46e1f79253d#DEVELOPER_PORTAL_READ',
        'BinoQ#BinoQManager#5986d7be-1600-40e0-84df-80fb403df83f#BINOQ_MANAGER'
      ],
      name: 'Elin Sunde Wilberg',
      preferred_username: 'elin.sunde.wilberg@tomra.com',
      given_name: 'Elin Sunde',
      family_name: 'Wilberg',
      full_resource_access: [
        'REPORTS_WRITE',
        'REPORTS_READ',
        'ACCOUNT_ADMIN',
        'LIST_INSTALLATIONS_FOR_USER',
        'LIST_ACTIVE_USERS_FOR_PRODUCT',
        'READ_ACCOUNT',
        'LIST_API_PRODUCTS_FOR_USER',
        'INSTALLATION_HAS_ACTIVE_LICENSE_ON_PRODUCT',
        'BACKOFFICE',
        'MYTOMRA_BACKOFFICE_READ',
        'VOUCHER_CONTROL_CHECK_INVOICE',
        'VOUCHER_CONTROL_ADMIN_MACHINE_SEARCH',
        'VOUCHER_CONTROL_ADMIN',
        'ENABLE_EVOUCHER',
        'VOUCHER_CONTROL_ARCHIVE_VOUCHERS',
        'VOUCHER_CONTROL_ADMIN_STATISTICS_SEARCH',
        'VOUCHER_CONTROL_ADMIN_EXPORT_RECEIPT',
        'VOUCHER_CONTROL_ADMIN_MANAGE_SOAP_CLIENTS',
        'VIEW_ASSORTMENT_MANAGEMENT',
        'VIEW_INSTALLATION_ASSORTMENT',
        'STATUS_WRITE',
        'STATUS_READ',
        'REPORTS_READ',
        'PROMOTION_TEMPLATE_READ',
        'PROMOTION_TEMPLATE_FULL_ACCESS',
        'PROMOTION_TEMPLATE_WRITE',
        'manage-account',
        'manage-account-links',
        'view-profile',
        'MASTERDATA_WRITE',
        'MASTERDATA_READ'
      ],
      email: 'elin.sunde.wilberg@tomra.com'
    }
    this.refreshTokenParsed = {}
    this.idTokenParsed = {}
  }

  init() {
    return new Promise(resolve => {
      resolve({
        token: this.token,
        refreshToken: this.refreshToken,
        idToken: this.idToken,
        tokenParsed: this.tokenParsed,
        refreshTokenParsed: this.refreshTokenParsed,
        idTokenParsed: this.idTokenParsed
      })
    })
  }

  logout() {
    return Promise.resolve()
  }

  updateToken() {
    return Promise.resolve(true)
  }
}

export { MockKeycloak }
